/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

/* eslint-disable no-duplicate-imports */
import { IImageData, Image } from '@msdyn365-commerce/core';
import { ISearchData } from '@msdyn365-commerce-modules/search';
import { Node } from '@msdyn365-commerce-modules/utilities';
import React from 'react';

import { ISearchProps } from '../../definition-extensions/search.ext.props.autogenerated';

/**
 * Render Products Suggestion result heading.
 * @param props -The props.
 * @returns The JSX Element.
 */
const renderProductNotFoundResultsImage = (props: ISearchProps<ISearchData>): JSX.Element | null => {
    const noSearchResultImage: IImageData | undefined = props.config.noSearchResultImage;
    if (!noSearchResultImage || !noSearchResultImage.src) {
        return null;
    }
    const imageSettings = {
        lazyload: true,
        viewports: {
            xs: { w: 100, h: 100, q: 'w=100&h=100&q=60&m=6' }
        }
    };
    return (
        // @ts-ignore
        <Image
            altText={noSearchResultImage.altText}
            className='msc-autoSuggest__productResults-no-results-image-img'
            gridSettings={props.context.request.gridSettings!}
            src={noSearchResultImage.src}
            requestContext={props.context.request}
            imageSettings={imageSettings}
        />
    );
};

/**
 * Render Product suggestion result.
 * @param props -The props.
 * @returns The JSX Element.
 */
export const MobileAutoSuggestEmptyComponent = (
    props: ISearchProps<ISearchData>
): JSX.Element => {
    return (
        <Node className='msc-autoSuggest__productResults-empty-mobile-content'>
            <div className='msc-autoSuggest__productResults-empty-mobile-no-results-image'>
                {renderProductNotFoundResultsImage(props)}
            </div>
            <div className='msc-autoSuggest__productResults-empty-mobile-text-content'>
                <div className='msc-autoSuggest__productResults-empty-mobile-heading'>
                    {props.resources.emptyMobileSearchTextHeading}
                </div>
                <div className='msc-autoSuggest__productResults-empty-mobile-text'>
                    {props.resources.emptyMobileSearchText}
                </div>
            </div>
        </Node>
    );
};
